export default __webpack_public_path__ + "static/media/user.177a2dce.svg";